var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSquaredTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 38,
    height: 38,
    rx: 8,
    fill: "#E41830"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 13.5H12.5833H27.25",
    stroke: "#E41830",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 13.5V11.6667C15.3333 11.1805 15.5264 10.7142 15.8702 10.3703C16.214 10.0265 16.6804 9.83337 17.1666 9.83337H20.8333C21.3195 9.83337 21.7858 10.0265 22.1296 10.3703C22.4734 10.7142 22.6666 11.1805 22.6666 11.6667V13.5M25.4166 13.5V26.3334C25.4166 26.8196 25.2234 27.2859 24.8796 27.6297C24.5358 27.9736 24.0695 28.1667 23.5833 28.1667H14.4166C13.9304 28.1667 13.464 27.9736 13.1202 27.6297C12.7764 27.2859 12.5833 26.8196 12.5833 26.3334V13.5H25.4166Z",
    stroke: "#E41830",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquaredTrash);
export default __webpack_public_path__ + "static/media/squared-trash.918a87ca664c2e497819c5d846e7d384.svg";
export { ForwardRef as ReactComponent };